module.exports = __webpack_public_path__ + "img/index.906eecb6.jpg";